import {
  BASE_PATH_ANALYTICS,
  BUTTONS_ANALYTICS,
  LINKS_ANALYTICS,
} from '@/constants/analytics'
import { getExperienceScreenName } from '@/pages/PortalValueProp/helpers/get-experience-screen-name'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'

export const eventDispatcherConfig = (): EventDispatcherConfig =>
  ({
    config: {
      screenName: getExperienceScreenName(),
      screenPath: `${BASE_PATH_ANALYTICS.PORTAL_OOBE}`,
    },
  }) as const

export const PortalValuePropPageAnalytics = createAnalyticsManifest(
  eventDispatcherConfig,
  ({ dispatcher }) => ({
    fireContinueButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.CONTINUE,
      })
    },
    fireCreateAccountButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.CREATE_ACCOUNT,
      })
    },
    fireSignInLinkClicked: () => {
      dispatcher.fireHyperLinkClicked({
        controlName: LINKS_ANALYTICS.SIGN_IN,
      })
    },
    fireFeatureLinkClicked: () => {
      dispatcher.fireHyperLinkClicked({
        controlName: LINKS_ANALYTICS.FEATURE_LINK,
      })
    },
    fireTermsOfUseLinkClicked: (uri: string) => {
      dispatcher.fireHyperLinkClicked({
        controlName: LINKS_ANALYTICS.HP_SMART_TOU,
        controlDetail: uri,
      })
    },
  }),
)
